import React from 'react'
import { DataTable } from '../../../CommonComponent'
import { Iprops } from './itemsummaryinterface'
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../../const/resource";

const ItemSummary = (props: Iprops) => {
    const { t } = useTranslation();

    const columns = [
        {
            field: "partNumber",
            title: t(RESOURCE.MyK_Grid_Part_Number),
            sortable: false,
            width: 135
        },
        {
            field: "partName",
            title: t(RESOURCE.MyK_Grid_Part_Name),
            sortable: false,
            width: 250
        },
        {
            field: "qtyStock",
            title: t(RESOURCE.MyK_Grid_Quantity_in_stock_here),
            sortable: false,
            width: 192
        }
    ]

    return (
        <div className='fullfillmentSummary'>
            <DataTable
                data={props?.partData?.partsAvailability ?? []}
                dataColumn={columns}
                className={'fullfillmentSummary'}
                pagination={false}
                defaultPageSize={props?.partData?.partsAvailability?.length ?? 0}
            />
        </div>
    )
}

export default ItemSummary;